import { gql } from '@apollo/client';
import { addTypePolicies } from 'src/lib/graphql/cache';
import useGQLPaginatedQuery from 'src/lib/graphql/hooks/useGQLPaginatedQuery';
import paginatedListFieldPolicy from 'src/lib/graphql/utils/paginatedListFieldPolicy';
export const NOTES_LIST_QUERY = gql `
  query Admin_NotesList($filters: EPNoteListFilters = {}, $pagination: PaginationOptions!) {
    ep_noteList(filters: $filters, pagination: $pagination) {
      totalCount
      list {
        id
        data {
          title
          topics
          slug
        }
        utime
      }
    }
  }
`;
export function useNotesListQuery(options) {
    return useGQLPaginatedQuery(NOTES_LIST_QUERY, 'ep_noteList', options);
}
addTypePolicies({
    Query: {
        fields: {
            ep_noteList: paginatedListFieldPolicy(['filters']),
        },
    },
});
